import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ISolarAddress } from 'app/interfaces/ISolarAddress';
import { ISolarObjects } from 'app/interfaces/ISolarObjects';
import { KeycloakService } from 'app/login/keycloak.service';
import { GlobalsService } from './globals.service';

@Injectable()
export class SolarReceiverService {
  constructor(
    private http: HttpClient,
    private globalService: GlobalsService,
    ) {
    }

    getSolarCollectorCodelist(): Observable<any> {
      return this.http
        .get<any>(
          this.globalService.getRestUrl() +
            '/api/planiranjeSoncniSprejemniki/getSolarCollectorCodelist',
        )
        .pipe(
          catchError(error => throwError(() => error))
        );
    }
    

    postSolarReceiverObjectsResults(data: ISolarObjects): Observable<any> {
      return this.http
        .post<any>(
          this.globalService.getRestUrl() +
            '/api/planiranjeSoncniSprejemniki/getSolarCollectorBuildingsByParams',
          data,
        )
        .pipe(
          catchError(error => throwError(() => error))
        );
    }


  postSolarReceiverAddressResults(data: ISolarAddress): Observable<any> {
    return this.http
        .post<any>(
          this.globalService.getRestUrl() +
           '/api/planiranjeSoncniSprejemniki/getSolarCollectorBuildingByAddress',
          data,
        )
        .pipe(
          catchError(error => throwError(() => error))
        );
  }
}
